import * as React from 'react'
import {
  withStyles,
  WithStyles,
  FormControlLabel,
  Checkbox,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
} from '@zn-material-ui'
import { transform } from '@utils/intl_lang'
import loginHelperStyles from './styles/LoginHelperStyle'
interface IProps extends WithStyles<typeof loginHelperStyles> {
  isNormalLogin: boolean
  rememberPwd: boolean
  handleRememberPwdChange: (event: any) => void
  handlePwdForgot: () => void
  handleRegister: () => void
  isPasswordType: boolean
  changeEmpLogin: (isPasswordType: boolean) => void
}

const LoginHelper: React.SFC<IProps> = props => {
  const { classes, rememberPwd, handleRememberPwdChange, changeEmpLogin, isPasswordType, ...rest } = props

  // 切换登录方式
  const onPasswordTypeChange = () => {
    if (isPasswordType) {
      changeEmpLogin(false)
    } else {
      changeEmpLogin(true)
    }
  }

  return (
    <div className={classes.helper}>
      {(rest.isNormalLogin && (
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={rememberPwd}
              onChange={handleRememberPwdChange}
              value="rememberPwd"
              color="primary"
            />
          }
          // 记住密码
          label={transform('Login_remember_pwd')}
          classes={{ label: classes.rememberPwd }}
        />
      )) ||
      <div className={classes.findPassword}>
        {isPasswordType ? <span className={classes.leftButton} onClick={onPasswordTypeChange}>验证码登录</span>
          : <span className={classes.leftButton} onClick={onPasswordTypeChange}>密码登录</span>}
      </div>
      }

      {/* <div className={classes.helperRight}>
        <div className={classes.pwdForgot} onClick={rest.handlePwdForgot}>
          {transform('Login_forgot_pwd')}
        </div>
        <div className={classes.divider} />
        <div className={classes.register} onClick={rest.handleRegister}>
          {transform('Login_register_accout')}
        </div>
      </div> */}
    </div>
  )
}

export default withStyles(loginHelperStyles)(LoginHelper)
